import { AffModels } from '@affiliate-cabinet/graphql'
import { ReportsTypesComponents } from '@affiliate-cabinet/types'
import { capitaliseString } from '@affstore-ds/helpers'
import { createEnumObject } from '@affstore-ds/types'

import { featuresStatuses } from '../../config/brands'
import { selectTranslationKeys } from '../../shared/translations/select.translationKeys'

// --- REST-aligned (v1) ---

type AffModelType = ReportsTypesComponents['schemas']['EnumAffModel']

export const AFF_MODEL_ENUM = createEnumObject<AffModelType>({
  cpa: 'cpa',
  lot: 'lot',
  revenue: 'revenue',
  spread: 'spread',
  turnover: 'turnover',
})

const KEY_TO_TRANSLATED_VALUE_V1: Record<AffModelType, string> = {
  [AFF_MODEL_ENUM.cpa]: AFF_MODEL_ENUM.cpa.toUpperCase(),
  [AFF_MODEL_ENUM.lot]: AFF_MODEL_ENUM.lot.toUpperCase(),
  [AFF_MODEL_ENUM.revenue]: capitaliseString(AFF_MODEL_ENUM.revenue),
  [AFF_MODEL_ENUM.spread]: capitaliseString(AFF_MODEL_ENUM.spread),
  [AFF_MODEL_ENUM.turnover]: capitaliseString(AFF_MODEL_ENUM.turnover),
}

export const affiliateModelEntity = {
  AFF_MODEL_ENUM,
  KEY_TO_TRANSLATED_VALUE: KEY_TO_TRANSLATED_VALUE_V1,
}

// --- GraphQL (deprecated) ---

/** @deprecated Use affiliateModelEntity (REST-aligned) */
const KEY_TO_TRANSLATED_VALUE = {
  [AffModels.Cpa]: AffModels.Cpa,
  [AffModels.Lot]: AffModels.Lot,
  [AffModels.Revenue]: capitaliseString(AffModels.Revenue),
  [AffModels.Spread]: capitaliseString(AffModels.Spread),
  [AffModels.Turnover]: capitaliseString(AffModels.Turnover),
}

/** @deprecated Use affiliateModelEntity (REST-aligned) */
const LIST = [
  {
    'data-testid': `affModels-item-not-selected`,
    translationKey: selectTranslationKeys.selectNotSelected,
    value: '',
  },
  { 'data-testid': `model-item-${AffModels.Cpa}`, label: KEY_TO_TRANSLATED_VALUE[AffModels.Cpa], value: AffModels.Cpa },
  { 'data-testid': `model-item-${AffModels.Lot}`, label: KEY_TO_TRANSLATED_VALUE[AffModels.Lot], value: AffModels.Lot },
  { 'data-testid': `model-item-${AffModels.Revenue}`, label: KEY_TO_TRANSLATED_VALUE[AffModels.Revenue], value: AffModels.Revenue },
  { 'data-testid': `model-item-${AffModels.Spread}`, label: KEY_TO_TRANSLATED_VALUE[AffModels.Spread], value: AffModels.Spread },
]

if (featuresStatuses.isAffModelTurnoverEnabled) {
  LIST.push({ 'data-testid': `model-item-${AffModels.Turnover}`, label: KEY_TO_TRANSLATED_VALUE[AffModels.Turnover], value: AffModels.Turnover })
}

/** @deprecated Use affiliateModelEntity (REST-aligned) */
export const affModelEntity = {
  KEY_TO_TRANSLATED_VALUE,
  LIST,
}
